module.exports = __webpack_public_path__ + "static/media/ship.3307bf34.svg";